/**
 * ddAddToCart — shared add-to-cart helper for all DD sections.
 *
 * Wraps /cart/add.js with a 5-second AbortController timeout, disables the
 * button during the request, and restores it automatically on error.
 *
 * @param {string|number} variantId
 * @param {number}        qty
 * @param {HTMLElement}   btn          - Button to lock/unlock
 * @param {Function}      onSuccess    - Called with (data, btn, originalLabel) on success
 */
window.ddAddToCart = function ddAddToCart(variantId, qty, btn, onSuccess) {
  var originalLabel = btn.textContent;
  btn.disabled = true;
  btn.textContent = btn.dataset.loadingText || '...';

  var controller = new AbortController();
  var timer = setTimeout(function () { controller.abort(); }, 5000);

  fetch('/cart/add.js', {
    method: 'POST',
    signal: controller.signal,
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) throw new Error(data.description || 'Error adding to cart');
      if (typeof onSuccess === 'function') onSuccess(data, btn, originalLabel);
    })
    .catch(function () {
      btn.textContent = originalLabel;
      btn.disabled = false;
    })
    .finally(function () {
      clearTimeout(timer);
    });
};